import { parseJwt } from '@digital/ui';
import { boolean } from 'yup';

interface JwtPayload {
  name: string;
  id: string;
  isMRN: boolean;
  codigoUsuario: string;
  exp: number;
}

export const getJwt = () => localStorage.idtoken;

export const getGraphJwt = () => localStorage['graph.access.token'];

export const getJwtPayload = () => parseJwt<JwtPayload>(getJwt());

export const setGraphJwt = (token: string | null) => (localStorage['graph.access.token'] = token);

export const setConnectorJwt = (token: string | null) => (localStorage['connector.access.token'] = token);

export const getLoggedUsername = () => {
  const jwt = getJwtPayload();
  return jwt ? decodeURIComponent(escape(jwt.name)) : decodeURIComponent(escape('AntÃ´nio Fagundes'));
};

export const getExpirationTime = () => {
  const jwt = getJwtPayload();
  return jwt ? jwt.exp : 0;
};

export const getLoggedId = () => {
  const jwt = getJwtPayload();
  return jwt ? jwt.id : '564652131dgdfgd';
};

export const getLoggedIsMRN = () => {
  return localStorage.getItem('isMRN') === 'true' ? true : false;
};

export const getCodigoUsuario = () => {
  return localStorage.getItem('codigoUsuario');
};
